// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tiny-only": "\"screen and (max-width: 20.9375em)\"",
	"small-tiny": "\"screen and (max-width: 44.9375em)\"",
	"pre-medium": "\"screen and (min-width: 58em)\"",
	"tiny": "\"screen and (min-width: 21em)\"",
	"small": "\"screen and (min-width: 30em)\"",
	"medium": "\"screen and (min-width: 45em)\"",
	"large": "\"screen and (min-width: 64em)\"",
	"print": "\"print\"",
	"touch": "\"(hover: none) and (pointer: coarse)\"",
	"landscape-small": "\"screen and (orientation: landscape) and (max-height: 30em)\"",
	"ie": "\"all and (-ms-high-contrast: none), (-ms-high-contrast: active)\""
};
export default ___CSS_LOADER_EXPORT___;
